<template>
  <el-form ref="passForm" class="form" :rules="rules" :model="form" label-width="100px">
    <!-- <el-form-item label="手机号">
      <el-input :value="phone" readonly></el-input>
    </el-form-item>
    <el-form-item label="图形验证码" prop="VCode">
      <div class="flex">
        <el-input v-model="form.VCode" placeholder="请输入验证码"> </el-input>
        <img :src="codeUrl" class="login-code-img" @click="refreshCode" style="height: 40px; width: 120px" />
      </div>
    </el-form-item>
    <el-form-item label="手机验证码" prop="code">
      <el-input v-model="form.code">
        <template slot="append">
          <span @click="senSms" style="display: inline-block;width: 70px;cursor: pointer;text-align: center;">{{ phoneCode }}</span>
        </template>
      </el-input>
    </el-form-item> -->
    <el-form-item label="新密码" prop="password">
      <el-input v-model="form.password" show-password></el-input>
    </el-form-item>
    <el-form-item label="确认密码" prop="localPassword">
      <el-input v-model="form.localPassword" show-password></el-input>
    </el-form-item>
    <div class="dialog-footer" style="text-align: right;margin-top: 60px;">
      <!-- <el-button v-loading="loading" @click="$emit('close')">取 消</el-button> -->
      <el-button v-loading="loading" type="primary" @click="submit">确 定</el-button>
    </div>
  </el-form>
</template>

<script>
import util from "@/util/util";
import { loginPic, userPwdModifySms, userPwdModify } from "@/api/base";
import { cryptoEncrypt } from "@/util/aes";

export default {
  computed: {
    phone() {
      return this.$store.state.user.userinfo.phone;
    },
  },
  mounted() {
    this.refreshCode();
  },
  data() {
    return {
      rules: {
        localPassword: [
          {
            required: true,
            message: "请确认密码",
            // trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            min: 8,
            max: 20,
            pattern: /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{8,20}$/,
            message: "密码需要使用大写字母、小写字母、数字及特殊符号中至少三种的组合,长度在 8 到 20 个字符",
            // trigger: "blur",
          },
          {
            pattern: /^(?!.*(012|123|234|345|456|567|678|789|987|876|765|654|543|432|321|210))[^\s]+$/,
            message: "不能包括3个连续的数字(如123，321)",
          },
        ],
        VCode: [{ required: true, message: "请输入图形验证码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      form: {
        password: "",
        code: "",
        VCode: "",
      },
      vid: "",
      codeUrl: "",
      phoneCode: "发送验证码",
      loading: false,
    };
  },
  methods: {
    refreshCode() {
      loginPic({}).then((res) => {
        this.codeUrl = res.pic;
        this.vid = res.validateId;
      });
    },
    senSms() {
      //发送验证码
      if (typeof this.phoneCode == "number") {
        return;
      }
      if (!this.form.VCode) {
        this.$err("请输入验证码!");
        return false;
      }
      userPwdModifySms({
        code: this.form.VCode,
        vid: this.vid,
      }).then(
        (res) => {
          this.phoneCode = 60;
          var idx = setInterval(() => {
            this.phoneCode--;
            if (this.phoneCode == 0) {
              clearInterval(idx);
              this.phoneCode = "发送验证码";
            }
          }, 1000);
        },
        (err) => {
          if (err.code == -1 && err.msg == "验证码不正确") {
            this.form.VCode = "";
            this.refreshCode();
          }
        },
      );
    },
    submit() {
      this.$refs.passForm.validate((valid) => {
        if (this.form.password != this.form.localPassword) {
          this.$err("两次密码输入输入不一致");
          return;
        }
        if (valid) {
          var form = {
            ...this.form,
            phone: this.phone,
            password: cryptoEncrypt(this.form.password),
          };

          this.loading = true;
          delete form.localPassword;
          userPwdModify(form)
            .then((res) => {
              this.$suc("修改密码成功!");
              this.$emit("close");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style></style>
